export default __webpack_public_path__ + "static/Bitter-BoldItalic-2ddb9ff06a05e0435f372d76ba795cd2.woff2";